<h1 class="sr-only"><span>PREMIOS COLABORADOR SORTEO ANÁHUAC MAGNO</span></h1>

<section id="premios-col" class="banner-padding">
    <div class="container">
        <div class="row sub-headers-inside">
            <div class="col-12 text-center my-auto">
                <div class="overlap-signature header-inside">

                    <span class="letter"> <span class="signature-text">Premios</span></span>
                    <h2 class="main-text">colaborador</h2>
                </div>


            </div>
        </div>
    </div>
</section>

<section class="premios-colb-cta">
    <div class="container  mb-5">
        <div class="row">
            <!-- 
                <div class="col-12 text-center my-auto">
                    <a (click)="scrollPage('#premios_cta')" class="cta d-xl-block d-none">
                        <img src="/assets/images/sorteo2023/arrow.png" class="img-fluid" >
                    </a>

                    <a (click)="scrollPage('#premios_cta2')" class="cta d-xl-none d-block">
                        <img src="/assets/images/sorteo2023/arrow.png" class="img-fluid" >
                    </a>
                </div> -->

            <div class="col-12 container-h mt-5">
                <h2>
                    Con Sorteo Anáhuac Todos ganan
                </h2>
                <p>
                    y todos nuestros colaboradores lo saben. Conoce nuestros
                    premios para
                    <span class="d-block">
                        colaborador donde tenemos un acumulado de más
                        de <strong class="t-bolder"> $3.8 millones de pesos</strong>.
                    </span>
                </p>

                <div class="w-100 text-center mt-5">
                    <img src="/assets/images/sorteo2026/price-col.jpg" class="img-fluid">
                </div>
            </div>





        </div>
    </div>
</section>

<!-- <section class="premios-colaborador">
    <div class="container">
        <div class="row ">
            <div class="col-md-12 text-center">
                <div class="controls ">
                    <a type="button" class="control btn-d"
                        data-filter="all"><span>Todos</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".pp"><span>1º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".sp"><span>2º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".tp"><span>3º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".cp"><span>4º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".qp"><span>5º premio</span></a>
                    <a type="button" class="control btn-d"
                        data-filter=".otros"><span>Ver más premios</span></a>
                </div>

                <div class="conainter-photos">
                    <div class="row">

                        <div class="col-12">
                            <div class="card-columns-init">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-1.jpg"
                                    class="img-fluid mix pp">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-2.jpg"
                                    class="img-fluid mix sp">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-3.jpg"
                                    class="img-fluid mix tp">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-4.jpg"
                                    class="img-fluid mix cp">

                                <img
                                    src="/assets/images/sorteo2025/premios-colab/premio-col-5.jpg"
                                    class="img-fluid mix qp">

                                <div class="row">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-6.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-7.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-8.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-9.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-10.jpg"
                                        class="img-fluid mix otros col-md-6">
                                    <img
                                        src="/assets/images/sorteo2025/premios-colab/premio-col-11.jpg"
                                        class="img-fluid mix otros col-md-6">
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="gap"></div>
                    <div class="gap"></div>
                    <div class="gap"></div>
                    <div class="gap"></div>
                </div>
            </div>

        </div>
    </div>
</section> -->


<section id="premios_cta">
    <div class="container contenedor-principal-glass">
        <div class="row justify-content-center">

             <div class="col-12 text-center mt-4 mb-4">
                <img src="/assets/images/sorteo2026/dinero.png" alt="" class="img-fluid img-premios">
                <div class="titulo-ganas">
                    <p class="si-boleto">Si tu boleto gana,</p>
                    <p class="tu-ganas">Tú ganas</p>
                </div>
            </div>

            <div class="col-6 text-right">
                <div class="line">
                    <p class="pill-award">1°</p>
                    <p class="pill-award">2°</p>
                    <p class="pill-award">3°</p>
                    <p class="pill-award">4°</p>
                    <p class="pill-award">5°</p>
                    <p class="pill-award">6° al 20°</p>
                    <p class="pill-award">21° al 30°</p>
                    <p class="pill-award">31° al 40°</p>
                    <p class="pill-award">41° al 50°</p>
                    <p class="pill-award">51° al 61°</p>
                    <p class="pill-award">62° al 460°</p>
                </div>
            </div>

            <div class="col-6 text-left">
                <div class="line">
                    <p class="pill-award">$500,000.00</p>
                    <p class="pill-award">$400,000.00</p>
                    <p class="pill-award">$300,000.00</p>
                    <p class="pill-award">$200,000.00</p>
                    <p class="pill-award">$100,000.00</p>
                    <p class="pill-award">$30,000.00</p>
                    <p class="pill-award">$15,000.00</p>
                    <p class="pill-award">$10,000.00</p>
                    <p class="pill-award">$5,000.00</p>
                    <p class="pill-award">$3,000.00</p>
                    <p class="pill-award">$2,000.00</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="button-cta">
    <div class="container">
        <div class="row">
              <div class="col-12 text-center  ">
                <a href="{{urlMicrositio}}" target="_blank" class="btn-stack ">compra ya</a>
                <p>
                    Ó
                </p>
                <a [routerLink]="['/formulario-registro-colaboradores']" class="btn-stack">Vuélvete colaborador</a>
            </div>


        </div>
    </div>
</section>